import React, { useState } from "react";
import logo from "../../images/TestAssessify.png";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { api } from "../../api";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import EmailVerificationModal from "./components/EmailVerificationModal";
import { useNavigate } from "react-router-dom";

const VerificationStatus = () => {
  const [inputEmail, setInputEmail] = useState("");
  const [isValid, setIsValid] = useState(true);
  const [showVerificationModal, setShowVerificationModal] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex =
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,63}(?:\.[A-Z]{1,63})?$/i;
    return emailRegex.test(email);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputEmail(value);
    setIsValid(validateEmail(value));
  };

  const handleVerifyEmail = async (e) => {
    e.preventDefault();

    if (!inputEmail) {
      toast.error(t("email-required"));
      return;
    }

    if (!isValid) {
      toast.error(t("invalid-email"));
      return;
    }

    try {
      toast.loading(t("checking-status"));
      const res = await api.verifyEmailStatus({ email: inputEmail });
      toast.remove();

      const verifiedAt = res?.data?.email_verified_at;

      if (verifiedAt) {
        toast.success(t("email-verified"));
        navigate(`/?email=${inputEmail}`);
      } else {
        toast.error(t("email-not-verified"));
        setShowVerificationModal(true);
      }
    } catch (error) {
      toast.remove();
      toast.error(error.response?.data?.message || t("something-went-wrong"));
    }
  };

  return (
    <div className="bg-white p-4 lg:p-10">
      <div className="w-full flex justify-between pb-3 h-26 bg-inherit sticky top-0 cursor-pointer">
        <div className="h-full">
          <img
            src={logo}
            alt="Test Assessify"
            className="w-56 h-full object-contain"
          />
        </div>
        <LanguageSwitcher
          className="border border-slate-300 mr-5 py-3 px-3 rounded-xl focus:border-slate-300 focus:outline-none"
          containerClassName="flex items-center justify-center"
        />
      </div>

      <div className="flex justify-center mt-16 2xl:mt-40 2xl:h-screen">
        <div className="bg-cover bg-no-repeat bg-hero-img w-full md:w-[600px] lg:w-[900px] 2xl:w-[1440px] 2xl:h-[500px] rounded-xl p-2 lg:p-10 sm:shadow-2xl">
          <div className="my-2 shadow-2xl rounded-[8px] bg-white w-full lg:w-1/2 p-6">
            <div className="flex flex-col justify-center">
              <h1 className="text-3xl text-darkBlue font-semibold mb-4">
                {t("Check Verification Status")}
              </h1>
              <p className="text-base text-slate-600 mb-6">
                {t("enter-your-email")}
              </p>

              <form
                onSubmit={handleVerifyEmail}
                className="flex flex-col gap-6"
              >
                <div className="flex relative">
                  <input
                    autoFocus
                    type="email"
                    placeholder={t("enter-your-email")}
                    value={inputEmail}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                {!isValid && inputEmail && (
                  <p className="text-red-500 text-sm">{t("invalid-email")}</p>
                )}

                <button
                  type="submit"
                  className="w-full px-4 py-3 rounded-lg font-semibold text-center text-white transition duration-200 ease-in bg-[#88a848] shadow-md focus:outline-none focus:ring-2"
                >
                  {t("check-status")}
                </button>
              </form>
            </div>
          </div>
        </div>
        {showVerificationModal && (
          <EmailVerificationModal
            email={inputEmail}
            setShowNotification={setShowVerificationModal}
          />
        )}
      </div>
    </div>
  );
};

export default VerificationStatus;
